<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';


const router = useRouter();
const route = useRoute();
const currentLang = ref(route.query.lang as string);
const reports = ref<string[]>([]);

const loadReportIDs = () => {
    const storedReports = JSON.parse(localStorage.getItem('savedReports') || '[]');
    reports.value = storedReports;
};

const goToResult = (reportID: string) => {
    router.push(`/results/${reportID}?lang=${currentLang.value}`);
};

onMounted(() => {
    loadReportIDs();
});
</script>

<template>
    <div class="faq-container">
        <Card v-for="report in reports" :key="report.id" class="report-card">
            <template #title>
                {{ report.name }}
            </template>
            <template #content>
                <p v-html="report.result"></p>
            </template>
            <template #footer>
                <div class="float-end">
                    <Button style="background-color: var(--tuev-light-blue) !important;" severity="success" label="" @click="goToResult(report.id)">
                        <template #icon>
                            <FontAwesomeIcon icon="arrow-right" />
                        </template>
                    </Button>
                </div>
            </template>
        </Card>
    </div>
</template>

<style scoped>
.faq-container {
    display: flex;
    gap: 1rem;
    max-width: 900px;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: center;
    justify-content: space-evenly;
    align-items: center;
    padding-top: 1rem;
    padding-bottom: 1rem;
}

.report-card {
    width: 280px;
}
</style>
